<div class="z-page-head z-rise">
  <div>
    <h1 class="z-page-title">Voz del cliente</h1>
    <p class="z-page-subtitle">
      Por qué opinan así: qué pesa en la recomendación, cómo salen los atributos
      de la experiencia, qué dicen los comentarios abiertos y qué área de la
      tienda señalan los detractores.
    </p>
  </div>

  <div class="z-page-actions">
    <button class="z-btn z-btn--glass" type="button" (click)="descargar()">
      <i class="bi bi-download" aria-hidden="true"></i> Descargar CSV
    </button>
  </div>
</div>

<app-filter-bar
  [fields]="filtros"
  [selected]="seleccion"
  (selectedChange)="onFiltros($event)" />

<app-section-tabs [tabs]="tabs" [active]="tab" (activeChange)="onTab($event)" />

@switch (tab) {
  @case ('drivers') {
    <!-- Drivers de recomendacion + Consideracion -->
    <div class="voz-tab" role="tabpanel" aria-labelledby="z-tab-drivers">

      <section class="z-panel z-rise z-rise-1">
        <header class="z-panel-head">
          <div>
            <h2 class="z-panel-title">Drivers de recomendación</h2>
            <p class="z-panel-hint">Peso de cada palanca sobre el total de menciones.</p>
          </div>
        </header>

        <div class="z-panel-body">
          <app-chart [options]="drivers" [height]="260" />
        </div>
      </section>

      <section class="z-panel z-rise z-rise-2">
        <header class="z-panel-head">
          <div>
            <h2 class="z-panel-title">Consideración</h2>
            <p class="z-panel-hint">Por qué eligen Zorro Abarrotero antes que otra opción.</p>
          </div>
        </header>

        <div class="z-panel-body">
          <app-chart [options]="consideracion" [height]="400" />
        </div>
      </section>

    </div>
  }

  @case ('atributos') {
    <!-- 12 variables de la encuesta con su CSAT -->
    <div class="voz-tab" role="tabpanel" aria-labelledby="z-tab-atributos">

      <section class="z-panel z-rise z-rise-1">
        <header class="z-panel-head">
          <div>
            <h2 class="z-panel-title">Atributos de la experiencia</h2>
            <p class="z-panel-hint">
              Toca el icono de HISTÓRICO para ver los 19 meses de una variable.
            </p>
          </div>

          <div class="z-panel-actions">
            <button class="z-btn z-btn--magenta" type="button" (click)="descargarAtributos()">
              <i class="bi bi-download" aria-hidden="true"></i> Descarga detalle
            </button>
          </div>
        </header>

        <div class="z-panel-body">
          <p class="z-legend voz-semaforo">
            <span><i class="voz-dot voz-dot--good" aria-hidden="true"></i>CSAT 65 o más</span>
            <span><i class="voz-dot voz-dot--mid" aria-hidden="true"></i>CSAT de 50 a 64</span>
            <span><i class="voz-dot voz-dot--bad" aria-hidden="true"></i>CSAT menor a 50</span>
          </p>

          <app-data-table
            [columns]="columnasAtributos"
        exportTitle="Atributos de la experiencia"
        [exportFilters]="filtrosTexto"
            [rows]="atributos"
            [exportButtons]="exportacion"
            [showLengthSelect]="true"
            [showInfo]="true"
            [pageSize]="25"
            [expandable]="true"
            (iconAction)="abrirHistoricoAtributo($event)" />
        </div>
      </section>

    </div>
  }

  @case ('comentarios') {
    <!-- Analisis de texto de los comentarios abiertos -->
    <div class="voz-tab" role="tabpanel" aria-labelledby="z-tab-comentarios">

      <section class="z-panel z-rise z-rise-1">
        <header class="z-panel-head">
          <div>
            <h2 class="z-panel-title">Mención por palanca</h2>
            <p class="z-panel-hint">Porcentaje de comentarios que tocan cada palanca.</p>
          </div>
        </header>

        <div class="z-panel-body">
          <app-chart [options]="mencionPorPalanca" [height]="300" />

          <p class="z-legend voz-legend">
            <span><i class="voz-dot voz-dot--teal" aria-hidden="true"></i>Mención total</span>
          </p>
        </div>
      </section>

      <section class="z-panel z-rise z-rise-2">
        <header class="z-panel-head">
          <div>
            <h2 class="z-panel-title">Orientación por palanca</h2>
            <p class="z-panel-hint">Reparto de comentarios positivos, neutros y negativos.</p>
          </div>
        </header>

        <div class="z-panel-body">
          <app-chart [options]="orientacionPorPalanca" [height]="340" />
        </div>
      </section>

      <section class="z-panel z-rise z-rise-3">
        <header class="z-panel-head">
          <div>
            <h2 class="z-panel-title">Palancas detectadas</h2>
            <p class="z-panel-hint">
              El icono de Detalle abre los encuestados que mencionaron la palanca.
            </p>
          </div>
        </header>

        <!-- z-table--sticky-first va en el contenedor y no en la <table>:
             <app-data-table> no expone la clase de su tabla y la regla global
             es de descendencia, asi que casa igual desde aqui. -->
        <div class="z-panel-body voz-palancas z-table--sticky-first">
          <app-data-table
            [columns]="columnasPalancas"
        exportTitle="Palancas detectadas"
        [exportFilters]="filtrosTexto"
            [rows]="filasPalancas"
            [exportButtons]="sinExportacion"
            [searchable]="false"
            [paginated]="false"
            [pageSize]="0"
            (iconAction)="abrirComentarios($event)" />
        </div>
      </section>

    </div>
  }

  @case ('area') {
    <!-- Area de la tienda señalada por los detractores -->
    <div class="voz-tab" role="tabpanel" aria-labelledby="z-tab-area">

      <p class="z-banner voz-banner z-rise z-rise-1">{{ bannerArea }}</p>

      <section class="z-panel z-rise z-rise-2">
        <header class="z-panel-head">
          <div>
            <h2 class="z-panel-title">Menciones por área</h2>
            <p class="z-panel-hint">
              Cambia la pregunta para ver qué área de la tienda señalan sus detractores.
            </p>
          </div>

          <div class="z-panel-actions">
            <!-- Etiqueta y cifra en piezas propias: cada una se mantiene
                 entera y el unico corte posible de la pastilla es el de en
                 medio, que es el que evita que desborde la cabecera. -->
            <span class="voz-detractores">
              <i class="voz-dot voz-dot--bad" aria-hidden="true"></i>
              <span>DETRACTORES:</span>
              <span>{{ detractores | number }}</span>
            </span>
          </div>
        </header>

        <div class="z-panel-body">
          <div class="voz-pregunta">
            <label class="z-sr-only" for="voz-pregunta-encuesta">Pregunta de la encuesta</label>

            <select class="z-native-select voz-pregunta-select"
                    id="voz-pregunta-encuesta"
                    [value]="preguntaSeleccionada"
                    (change)="onPregunta($any($event.target).value)">
              @for (pregunta of preguntas; track pregunta) {
                <option [value]="pregunta">{{ pregunta }}</option>
              }
            </select>
          </div>

          <div class="voz-area-tabla">
            <app-data-table
              [columns]="columnasArea"
        exportTitle="Menciones por área"
        [exportFilters]="filtrosTexto"
              [rows]="filasArea"
              [exportButtons]="exportacionArea"
              [showInfo]="true"
              [expandable]="true"
              [pageSize]="10"
              (iconAction)="abrirHistoricoArea($event)" />
          </div>
        </div>
      </section>

      <section class="z-panel z-rise z-rise-3">
        <header class="z-panel-head">
          <div>
            <h2 class="z-panel-title">Desviación histórica</h2>
            <p class="z-panel-hint">
              19 meses de «{{ areaDestacada }}», el área con más menciones de esta
              pregunta. El icono de HISTÓRICO de la tabla abre cualquier otra.
            </p>
          </div>
        </header>

        <div class="z-panel-body">
          <app-chart [options]="desviacionHistorica" [height]="340" />
        </div>
      </section>

    </div>
  }
}

@if (comentariosAbiertos) {
  <app-modal title="Detalle:" [wide]="true" (closed)="cerrarComentarios()">
    <div class="voz-comentarios">
      <app-data-table
        [columns]="columnasComentarios"
        exportTitle="Comentarios por palanca"
        [exportFilters]="filtrosTexto"
        [rows]="filasComentarios"
        [showLengthSelect]="true"
        [showInfo]="true"
        [expandable]="true" />
    </div>
  </app-modal>
}

@if (historicoAbierto) {
  <app-history-modal
    [title]="historicoTitulo"
    [points]="historicoPuntos"
    (closed)="cerrarHistorico()" />
}
